import Colors from "../Colors";

const baseWeapon = {
  displayPriority: 10,
  glyph: {
    fg: Colors.B_GREY_4,
    ch: "}",
  },
};

export const shields = {
  bLid: {
    ...baseWeapon,
    text: {
      name: "Barrel Lid",
      info:
        "Blocks stability can leave you staggered if you block too many attacks.",
      description:
        "One leather strap poorly latched to the wood is all it takes to make a shield.",
      logName: "B. Lid",
    },
    stats: {
      weight: 2,
    },
    attacks: {
      onehanded: {
        blocks: 0.65,
        stability: 80,
        stamina: 0,
        strength: 1,
      },
      twohanded: {
        blocks: 0.65,
        stability: 80,
        stamina: 0,
        strength: 1,
      },
    },
  },
  buckler: {
    ...baseWeapon,
    text: {
      name: "Ornamental Buckler",
      info: "A modest stability makes for an effective block.",
      description:
        "The church has turned a blind eye to these defensive instruments. Perhaps because many feature religious symbolism.",
      logName: "Buckler",
    },
    stats: {
      weight: 6,
    },
    attacks: {
      onehanded: {
        blocks: 0.8,
        stability: 90,
        stamina: 0,
        strength: 2,
      },
      twohanded: {
        blocks: 0.8,
        stability: 90,
        stamina: 0,
        strength: 1,
      },
    },
  },
  barricade: {
    ...baseWeapon,
    text: {
      name: "Fortified Barricade",
      info: "Total defense but heavy as a house.",
      description:
        "Unclear if any single person should even be carrying this around alone.",
      logName: "Barricade",
    },
    stats: {
      weight: 14,
    },
    attacks: {
      onehanded: {
        blocks: 0.5,
        stability: 95,
        stamina: 0,
        strength: 6,
      },
      twohanded: {
        blocks: 0.95,
        stability: 95,
        stamina: 0,
        strength: 3,
      },
    },
  },
} as const;
